import React from 'react';

const DEVICES = [
    { id: 'desktop', label: 'Desktop', width: 1280 },
    { id: 'tablet', label: 'Tablet', width: 768 },
    { id: 'mobile', label: 'Mobile', width: 375 },
];

export { DEVICES };

function Toggle({ label, checked, onChange }) {
    return (
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, color: 'var(--ink-3)' }}>
            <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
            {label}
        </label>
    );
}

export const FILTERS = [
    { id: 'all', label: 'All' },
    { id: 'untranslated', label: 'Untranslated' },
    { id: 'lowconf', label: 'Low confidence' },
    { id: 'overflow', label: 'Overflow' },
    { id: 'comments', label: 'Comments' },
];

export default function OverlayToolbar({ device, setDevice, overlays, setOverlays, summary, filter, setFilter, reviewMode, setReviewMode }) {
    const set = (key) => (val) => setOverlays((o) => ({ ...o, [key]: val }));

    return (
        <div style={{
            display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12,
            background: 'var(--bg-card)', border: '1px solid var(--line)',
            borderRadius: 12, padding: 12, marginBottom: 16,
        }}>
            <div className="pv-seg">
                {DEVICES.map((d) => (
                    <button
                        key={d.id}
                        type="button"
                        className={device === d.id ? 'on' : ''}
                        onClick={() => setDevice(d.id)}
                    >
                        {d.label}
                    </button>
                ))}
            </div>

            <span style={{ width: 1, height: 20, background: 'var(--line)' }} />

            <Toggle label="Source" checked={overlays.showSource} onChange={set('showSource')} />
            <Toggle label="Status" checked={overlays.showStatus} onChange={set('showStatus')} />
            <Toggle label="Overflow" checked={overlays.showOverflow} onChange={set('showOverflow')} />
            <Toggle label="Confidence" checked={overlays.showConfidence} onChange={set('showConfidence')} />
            <Toggle label="Terms" checked={overlays.showTerms} onChange={set('showTerms')} />
            <Toggle label="Pseudo" checked={overlays.showPseudo} onChange={set('showPseudo')} />

            <span style={{ width: 1, height: 20, background: 'var(--line)' }} />

            <div className="pv-seg">
                {FILTERS.map((f) => (
                    <button
                        key={f.id}
                        type="button"
                        className={filter === f.id ? 'on' : ''}
                        onClick={() => setFilter(f.id)}
                    >
                        {f.label}
                    </button>
                ))}
            </div>

            <span style={{ flex: 1 }} />

            {summary && summary.atRisk > 0 && (
                <span style={{
                    fontSize: 12, color: 'var(--danger, #d1242f)',
                    background: 'rgba(209,36,47,0.06)', border: '1px solid var(--line)',
                    borderRadius: 8, padding: '4px 10px', fontWeight: 600,
                }}>
                    {summary.atRisk} at overflow risk
                </span>
            )}

            <button
                type="button"
                className={reviewMode ? 'pv-btn sm primary' : 'pv-btn sm'}
                onClick={() => setReviewMode((v) => !v)}
                title="Toggle inline editing and approval controls"
            >
                {reviewMode ? 'Review mode: on' : 'Review mode'}
            </button>
        </div>
    );
}
